(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["df-project-pricing"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('df-project-pricing')) {
  customElements.define('df-project-pricing', class extends HTMLElement {});
}
document.querySelectorAll('[data-dfp]').forEach(root => {
  if (root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';
  const form = root.querySelector('form');
  if (!form) return;
  const main = root.querySelector('[data-dfp-main]');
  const consent = root.querySelector('[data-dfp-consent]');
  const next = root.querySelector('[data-dfp-next]');
  const back = root.querySelector('[data-dfp-back]');
  const callback = root.querySelector('[data-dfp-callback]');
  const area = root.querySelector('[data-dfp-area]');
  const qualifier = root.querySelector('[data-dfp-qualifier]');

  area?.addEventListener('input', () => {
    qualifier.hidden = !(Number(area.value) >= 1000);
  });

  next?.addEventListener('click', () => {
    if (!form.reportValidity()) return;
    main.hidden = true;
    consent.hidden = false;
    consent.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
  });

  back?.addEventListener('click', () => {
    consent.hidden = true;
    main.hidden = false;
  });

  root.querySelectorAll('[data-dfp-submit]').forEach(button => button.addEventListener('click', () => {
    callback.value = button.dataset.dfpSubmit === 'yes'
      ? 'Yes — call within 5 minutes during business hours'
      : 'No urgent call requested';
  }));

  const params = new URLSearchParams(location.search);
  const handle = params.get('product');
  const variantId = params.get('variant');
  if (!handle || !/^[a-z0-9-]+$/.test(handle)) return;

  fetch('/products/' + encodeURIComponent(handle) + '.js', {headers:{Accept:'application/json'}})
    .then(response => response.ok ? response.json() : Promise.reject())
    .then(product => {
      const variant = product.variants.find(item => String(item.id) === String(variantId)) || product.variants[0];
      const title = product.title || '';
      const specs = [variant?.title && variant.title !== 'Default Title' ? variant.title : '', variant?.sku ? 'SKU ' + variant.sku : '', product.vendor || ''].filter(Boolean).join(' · ');
      const productBox = root.querySelector('[data-dfp-product]');
      const image = root.querySelector('[data-dfp-image]');
      root.querySelector('[data-dfp-title]').textContent = title;
      root.querySelector('[data-dfp-specs]').textContent = specs;
      root.querySelector('[data-dfp-product-input]').value = title;
      root.querySelector('[data-dfp-spec-input]').value = specs;
      root.querySelector('[data-dfp-url]').value = location.origin + '/products/' + handle;
      if (product.featured_image) { image.src = product.featured_image; image.alt = title; }
      productBox.hidden = false;
    })
    .catch(() => {});
});

  } catch(e) { console.error(e); }
})();
})();
